window.addEventListener('DOMContentLoaded', initHeader);

function initHeader() {
  const header = document.querySelector('#main-header');
  if (!header) return;

  const mobileMenuToggle = header.querySelector('#mobile-menu-toggle');
  const mainMenuItems = document.querySelectorAll(
    '#main-menu .menu-item, #mobile-menu .menu-item, #main-flyout .menu-item',
  );
  const flyout = document.querySelector('#main-flyout');
  const flyoutItems = flyout?.querySelectorAll('#main-flyout .flyout-item');
  const flyoutOverlay = document.querySelector('#flyout-overlay');

  if (!mobileMenuToggle || mainMenuItems.length === 0 || !flyout || flyoutItems.length === 0 || !flyoutOverlay) {
    return;
  }

  for (const menuItem of mainMenuItems) {
    menuItem.addEventListener('mouseover', () => menuItemCallback('mouseover'), { passive: true });
    menuItem.addEventListener('click', (event) => menuItemCallback('click', event));

    if (menuItem.querySelector('.current')) {
      menuItem.classList.add('has-current');
    }

    function menuItemCallback(event, clickEvent) {
      const isMobile = window.innerWidth < 1280;
      const isDesktop = window.innerWidth > 1279;
      const hasIdentifier = Boolean(menuItem.dataset.identifier);
      const clickedLink = event === 'click' && clickEvent?.target?.closest('.menu-item-content');
      const isBackItem = menuItem.classList.contains('menu-back');
      const mobileMouseover = event === 'mouseover' && isMobile;
      const mobileClick = event === 'click' && isMobile && !hasIdentifier;
      const desktopClick = event === 'click' && isDesktop;
      const desktopLevel = event === 'mouseover' && isDesktop && menuItem.dataset.level > 0;
      if (mobileMouseover || mobileClick || desktopClick || desktopLevel) return;
      if (event === 'click' && isMobile && hasIdentifier && clickedLink && !isBackItem) return;
      const identifier = menuItem.dataset.identifier;
      identifier ? openFlyout(identifier) : closeFlyout();
    }
  }

  mobileMenuToggle.addEventListener(
    'click',
    () => {
      const identifier = mobileMenuToggle.dataset.identifier;
      if (mobileMenuToggle.classList.contains('is-open')) closeFlyout();
      else if (identifier) openFlyout(identifier);
    },
    { passive: true },
  );

  flyoutOverlay.addEventListener(
    'mouseover',
    () => {
      if (window.innerWidth > 1279) closeFlyout();
    },
    { passive: true },
  );
  flyoutOverlay.addEventListener('click', closeFlyout, { passive: true });

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Escape') closeFlyout();
    },
    { passive: true },
  );

  window.addEventListener('resize', () => {
    adjustFlyoutHeight();
    const mobileMenuOpen = flyout.querySelector('#mobile-menu.is-open') || false;
    if (window.innerWidth >= 1279 && mobileMenuOpen) closeFlyout();
  });

  function openFlyout(identifier) {
    for (const menuItem of mainMenuItems) {
      toggleElementByIdentifier(menuItem, identifier);
    }

    for (const flyoutItem of flyoutItems) {
      toggleElementByIdentifier(flyoutItem, identifier);
    }

    function toggleElementByIdentifier(element, identifier) {
      element.classList.toggle('is-open', element.dataset.identifier === identifier);
    }

    adjustFlyoutHeight();

    flyout.classList.add('is-open');
    flyoutOverlay.classList.add('is-open');
    mobileMenuToggle.classList.add('is-open');
  }

  function adjustFlyoutHeight() {
    const activeFlyoutItem = [...flyoutItems].filter((item) => item.classList.contains('is-open'))[0];

    if (!activeFlyoutItem) return;

    const currentFlyoutItemHeight = activeFlyoutItem.querySelector('.flyout-item-container')?.scrollHeight || 0;

    for (const flyoutItem of flyoutItems) {
      flyoutItem.style.setProperty('--flyout-item-height', `${currentFlyoutItemHeight}px`);
    }

    const currentFlyoutContent = activeFlyoutItem.querySelector('.flyout-content');
    const leftSpacing = activeFlyoutItem.querySelector('.flyout-menu')?.getBoundingClientRect()?.left || 0;
    if (leftSpacing !== 0) {
      currentFlyoutContent.style.setProperty('--backdrop-width', `calc(${leftSpacing}px - 2rem)`);
    }
  }

  function closeFlyout() {
    for (const menuItem of mainMenuItems) {
      menuItem.classList.remove('is-open');
    }

    for (const flyoutItem of flyoutItems) {
      flyoutItem.classList.remove('is-open');
    }

    flyout.classList.remove('is-open');
    flyoutOverlay.classList.remove('is-open');
    mobileMenuToggle.classList.remove('is-open');
  }
}
